import { useCallback, useRef } from 'react';

/** DUPE OF SHARED helper */
const publicUrl = (path: string) => {
  const publicUrl = process.env.PUBLIC_URL!.endsWith('/')
    ? process.env.PUBLIC_URL
    : `${process.env.PUBLIC_URL}/`;

  const normalizedPath = path.startsWith('/') ? path.substring(1) : path;
  return `${publicUrl}${normalizedPath}`;
};

/** Exposes a function to open a tab with a specific route and a ref to that tab.
 *
 * This way we can programmatically access it and execute actions like closing it.*/
export const useActionTab = ({
  tabRoute,
  target = 'action',
  width,
  height,
}: {
  tabRoute: string;
  target?: string;
  width?: number;
  height?: number;
}) => {
  const actionTabRef = useRef<Window | null>(null);
  const openActionTab = useCallback(() => {
    actionTabRef.current = window.open(
      publicUrl(tabRoute),
      target,
      `popup,width=${width ?? 1300},height=${height ?? 800}`
    );
  }, [tabRoute, target, width, height]);
  return { openActionTab, actionTabRef };
};
